import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useContext } from 'react';
import ServicesContext from '../../global/services/ServicesContext';
import { configurationKeys } from './queryKeyFactory';

export function useGetMultiFileUploadLimit(indexId?: number): UseQueryResult<number, unknown> {
  const servicesCtx = useContext(ServicesContext);

  const getMultiFileUploadLimit = () => {
    if (servicesCtx?.configurationService && indexId != null) {
      return servicesCtx.configurationService.getMultiFileUploadLimit(indexId);
    }
    throw new Error('Services context not initialized');
  };

  return useQuery({
    queryKey: configurationKeys.multiFileUploadLimit(indexId),
    queryFn: getMultiFileUploadLimit,
    retry: 0,
    staleTime: Infinity,
    gcTime: 180000,
    enabled: indexId != null
  });
}
